(() => {
  const select = document.getElementById('shf-variant');
  if (!select) return;
  const price = document.getElementById('shf-variant-price');
  const image = document.getElementById('shf-variant-image');
  const add = document.getElementById('shf-add');
  select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    price.textContent = option.dataset.price;
    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.removeAttribute('srcset');
      image.alt = option.dataset.alt || option.textContent;
    }
    const open = add.dataset.storeOpen === 'true';
    const available = option.dataset.available === 'true';
    add.disabled = !open || !available;
    add.textContent = !open ? 'Coming soon' : available ? 'Add to bag' : 'Sold out';
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  });
})();
